export enum MixpanelEvents {
    pageView = 'CI2.0 Page View',
    pageExit = 'CI2.0 Page Exit',
    logAnalyzerSearch = 'CI2.0 Log Analyzer Search',
    reportCreation = 'CI2.0 Report Creation',
    campaignWhatsappSearch = 'CI2.0 Campaign Whatsapp Search',
    campaignWhatsappRetarget = 'CI2.0 Campaign Whatsapp Retarget'

}